import React from 'react'
import ReactModal from 'react-modal'
import styled from 'styled-components'

ReactModal.setAppElement('#root')

const ReactModalAdapter = ({ className, modalClassName, ...props }) => (
  <ReactModal className={modalClassName} portalClassName={className} bodyOpenClassName='portalOpen' {...props} />
)

const Modal = styled(ReactModalAdapter).attrs({
  overlayClassName: 'overlay',
  modalClassName: 'modal',
})`
  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 999;
  }

  .modal {
    padding: 24px;
    background-color: ${({ theme }) => theme.colors.white};
    box-shadow: ${({ theme }) => theme.shadows.under[2]};
    border-radius: ${({ theme }) => theme.radii.default};
    max-height: 90vh;
    overflow-y: auto;
  }
`

Modal.propTypes = {
  ...ReactModal.propTypes,
}

export default Modal
